/**
 * NARRATIVE WIDGETS READY EVENT BUS
 *
 * A tiny pub/sub system to notify when narrative widgets (reportSummary, automatedNarrative)
 * have finished loading their async data.
 *
 * Widgets call `emitWidgetReady(widgetId)` when their data arrives.
 * The ReportPageHeader subscribes via `onWidgetReady(cb)` to track readiness.
 */

export type WidgetReadyPayload = { widgetId: string };

const BUS = new EventTarget();
const EVT = 'narrative:widget-ready';

/**
 * Emit when a narrative widget has finished loading.
 */
export function emitWidgetReady(widgetId: string | number): void {
    BUS.dispatchEvent(new CustomEvent<WidgetReadyPayload>(EVT, { detail: { widgetId: String(widgetId) } }));
}

/**
 * Subscribe to widget-ready events.
 * Returns a cleanup function for unsubscribing.
 */
export function onWidgetReady(cb: (payload: WidgetReadyPayload) => void): () => void {
    const handler = (e: CustomEvent<WidgetReadyPayload>) => {
        cb(e.detail);
    };
    BUS.addEventListener(EVT, handler as EventListener);
    return () => BUS.removeEventListener(EVT, handler as EventListener);
}
